import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=f31642ca&scoped=true&"
import script from "./BoxIcon.vue?vue&type=script&lang=js&"
export * from "./BoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31642ca",
  null
  
)

export default component.exports